export default __webpack_public_path__ + "static/recovery-specialists-d7aa89c051222f2d151e27f2bbce603b.png";